import { FC, SyntheticEvent } from 'react';

import classNames from 'classnames';

import './Tab.scss';

import { TestMetadata } from '../types';

export interface LinkProps {
  to: string;
  role: string;
}

export interface Components {
  /** React Router link */
  Link: FC<LinkProps>;
}

export interface TabProps {
  /** Classname of tab */
  className?: string;
  /** Determines if tab is active */
  active?: boolean;
  /** Route to go to when tab is clicked */
  to?: string;
  /** Determines if tab is disabled */
  disabled?: boolean;
  components?: Components;
  onClick?: (e?: SyntheticEvent) => void;
  // Test IDs for component sections
  testMetadata?: TestMetadata;
  /** Name of Font Awesome icon to show or custom icon component */
  labelIcon?: string | JSX.Element;
  /** Name of Font Awesome icon to show or custom icon component */
  labelIconLeft?: string | JSX.Element;
}

const Tab: FC<TabProps> = ({
  to = '/',
  active,
  disabled,
  children,
  components,
  className,
  testMetadata,
  labelIcon,
  labelIconLeft,
  ...props
}) => {
  const tabProps: TabProps = {
    ...props,
    className: classNames(
      'sb-tab',
      {
        ['sb-tab_active']: active,
        ['sb-tab_disabled']: disabled,
      },
      className,
    ),
  };

  if (components && components.Link) {
    return (
      <components.Link
        {...tabProps}
        to={to}
        role="tab"
        aria-selected={active}
        {...testMetadata}
      >
        {children}
      </components.Link>
    );
  } else {
    return (
      <div {...tabProps} role="tab" aria-selected={active} {...testMetadata}>
        <div className="sb-tab_content">
          {labelIconLeft && (
            <span role="icon" className="sb-tab_active-icon_left">
              {labelIconLeft}
            </span>
          )}
          {children}
          {labelIcon && (
            <span role="icon" className="sb-tab_active-icon_right">
              {labelIcon}
            </span>
          )}
        </div>
      </div>
    );
  }
};

export default Tab;
